import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PAGE_SIZES } from '@/components/ui/data-pagination';
import { RequestsTab } from '@/pages/record-and-send/requests/requests-tab';
import { REQUEST_STATUS_FILTERS } from '@/pages/record-and-send/requests/requests-search';

const requestsSearchSchema = z.object({
	status: z.enum(REQUEST_STATUS_FILTERS).optional().catch(undefined),
	q: z.string().optional().catch(undefined),
	page: z.coerce.number().int().min(1).optional().catch(undefined),
	pageSize: z.coerce
		.number()
		.refine((size) => PAGE_SIZES.includes(size))
		.optional()
		.catch(undefined),
});

function VideoTypeRequestsTab() {
	const { videoTypeId } = Route.useParams();
	return <RequestsTab videoTypeId={videoTypeId} />;
}

export const Route = createFileRoute('/_authenticated/_app/record-and-send/video-types/$videoTypeId/requests')({
	validateSearch: requestsSearchSchema,
	component: VideoTypeRequestsTab,
});
